import {createAction} from '@reduxjs/toolkit'

const DigitalContentEvent = {
    DIGITAL_CONTENT_TOGGLE: 'DIGITAL_CONTENT_TOGGLE',
} as const

const PointPaymentEvent = {
    POINT_PAYMENT_INPUT_BLUR: 'POINT_PAYMENT_INPUT_BLUR',
    POINT_PAYMENT_INPUT_CLEAR: 'POINT_PAYMENT_INPUT_CLEAR',
    POINT_PAYMENT_OPEN_TOOLTIP: 'POINT_PAYMENT_OPEN_TOOLTIP',
    POINT_PAYMENT_USE_ALL: 'POINT_PAYMENT_USE_ALL',
    POINT_PAYMENT_USE_ALL_ON: 'POINT_PAYMENT_USE_ALL_ON',
    POINT_PAYMENT_USE_ALL_OFF: 'POINT_PAYMENT_USE_ALL_OFF',
    POINT_PAYMENT_SHOW_AFFILIATE_POINT: 'POINT_PAYMENT_SHOW_AFFILIATE_POINT',
    POINT_PAYMENT_SHOW_AFFILIATE_POINT_FIND: 'POINT_PAYMENT_SHOW_AFFILIATE_POINT_FIND',
    POINT_PAYMENT_CONNECT_ACCOUNT: 'POINT_PAYMENT_CONNECT_ACCOUNT',
    POINT_PAYMENT_PAY_LATER_USE_ON: 'POINT_PAYMENT_PAY_LATER_USE_ON',
    POINT_PAYMENT_PAY_LATER_USE_OFF: 'POINT_PAYMENT_PAY_LATER_USE_OFF',
    POINT_PAYMENT_PAY_LATER_JOIN: 'POINT_PAYMENT_PAY_LATER_JOIN',
    POINT_PAYMENT_PAY_LATER_INPUT: 'POINT_PAYMENT_PAY_LATER_INPUT',
    POINT_PAYMENT_PAY_LATER_INPUT_CLEAR: 'POINT_PAYMENT_PAY_LATER_INPUT_CLEAR',
    POINT_PAYMENT_PAY_LATER_REDEEM: 'POINT_PAYMENT_PAY_LATER_REDEEM',
    POINT_PAYMENT_PAY_LATER_USE_ALL: 'POINT_PAYMENT_PAY_LATER_USE_ALL',
    POINT_PAYMENT_PAY_LATER_NOT_CANDIDATE_USE: 'POINT_PAYMENT_PAY_LATER_NOT_CANDIDATE_USE',
} as const

const PaymentMethodEvent = {
    PAYMENT_METHOD_PAYMONEY_ON: 'PAYMENT_METHOD_PAYMONEY_ON',
    PAYMENT_METHOD_RECHARGING_POINT_ON: 'PAYMENT_METHOD_RECHARGING_POINT_ON',
    PAYMENT_METHOD_RECHARGE_TOOLTIP: 'PAYMENT_METHOD_RECHARGE_TOOLTIP',
    PAYMENT_METHOD_CONNECT_PAYMONEY_ACCOUNT: 'PAYMENT_METHOD_CONNECT_PAYMONEY_ACCOUNT',
    PAYMENT_METHOD_CONNECT_RECHARGING_ACCOUNT: 'PAYMENT_METHOD_CONNECT_RECHARGING_ACCOUNT',
    PAYMENT_METHOD_COMPLEX_PAYMONEY_PAYMENT_OFF: 'PAYMENT_METHOD_COMPLEX_PAYMONEY_PAYMENT_OFF',
    PAYMENT_METHOD_COMPLEX_PAYMENT_OFF: 'PAYMENT_METHOD_COMPLEX_PAYMENT_OFF',
    PAYMENT_METHOD_PAYMONEY_AMOUNT: 'PAYMENT_METHOD_PAYMONEY_AMOUNT',
    PAYMENT_METHOD_RECHARGING_AMOUNT: 'PAYMENT_METHOD_RECHARGING_AMOUNT',
    PAYMENT_METHOD_PAYMONEY_ACCOUNT: 'PAYMENT_METHOD_PAYMONEY_ACCOUNT',
    PAYMENT_METHOD_RECHARGING_ACCOUNT: 'PAYMENT_METHOD_RECHARGING_ACCOUNT',
    PAYMENT_METHOD_ADD_PAYMONEY_RECHARGING_ACCOUNT: 'PAYMENT_METHOD_ADD_PAYMONEY_RECHARGING_ACCOUNT',
    PAYMENT_METHOD_ADD_RECHARGING_ACCOUNT: 'PAYMENT_METHOD_ADD_RECHARGING_ACCOUNT',
    PAYMENT_METHOD_RECHARGE_PROMOTION_BANNER: 'PAYMENT_METHOD_RECHARGE_PROMOTION_BANNER',
    PAYMENT_METHOD_EASY_ACCOUNT_ON: 'PAYMENT_METHOD_EASY_ACCOUNT_ON',
    PAYMENT_METHOD_ADD_EASY_ACCOUNT: 'PAYMENT_METHOD_ADD_EASY_ACCOUNT',
    PAYMENT_METHOD_SWIPE_EASY_ACCOUNT: 'PAYMENT_METHOD_SWIPE_EASY_ACCOUNT',
    PAYMENT_METHOD_EASY_CARD_ON: 'PAYMENT_METHOD_EASY_CARD_ON',
    PAYMENT_METHOD_ADD_EASY_CARD: 'PAYMENT_METHOD_ADD_EASY_CARD',
    PAYMENT_METHOD_SWIPE_EASY_CARD: 'PAYMENT_METHOD_SWIPE_EASY_CARD',
    PAYMENT_METHOD_EASY_CARD_TOP_BANNER_CLICK: 'PAYMENT_METHOD_EASY_CARD_TOP_BANNER_CLICK',
    PAYMENT_METHOD_NORMAL_PAY_ON: 'PAYMENT_METHOD_NORMAL_PAY_ON',
    PAYMENT_METHOD_FAMILY_PAY_ON: 'PAYMENT_METHOD_FAMILY_PAY_ON',
    PAYMENT_METHOD_FAMILY_PAY_MESSAGE_ON: 'PAYMENT_METHOD_FAMILY_PAY_MESSAGE_ON',
    PAYMENT_METHOD_FAMILY_PAY_TOOLTIP_ON: 'PAYMENT_METHOD_FAMILY_PAY_TOOLTIP_ON',
    PAYMENT_METHOD_CREDIT_CARD_ON: 'PAYMENT_METHOD_CREDIT_CARD_ON',
    PAYMENT_METHOD_MOBILE_ON: 'PAYMENT_METHOD_MOBILE_ON',
    PAYMENT_METHOD_VOUCHER_ON: 'PAYMENT_METHOD_VOUCHER_ON',
    PAYMENT_METHOD_MONEY_TOKEN_ON: 'PAYMENT_METHOD_MONEY_TOKEN_ON',
    PAYMENT_METHOD_WELFARE_CARD_ON: 'PAYMENT_METHOD_WELFARE_CARD_ON',
    PAYMENT_METHOD_CULTURE_LAND_ON: 'PAYMENT_METHOD_CULTURE_LAND_ON',
    PAYMENT_METHOD_HAPPY_MONEY_ON: 'PAYMENT_METHOD_HAPPY_MONEY_ON',
    PAYMENT_METHOD_PAYPAL_ON: 'PAYMENT_METHOD_PAYPAL_ON',
    PAYMENT_METHOD_PAY_NEXT_ON: 'PAYMENT_METHOD_PAY_NEXT_ON',
    PAYMENT_METHOD_SAMSUNG_PAY_ON: 'PAYMENT_METHOD_SAMSUNG_PAY_ON',
    PAYMENT_METHOD_SAMSUNG_PAY_PAY_MONEY_BANNER: 'PAYMENT_METHOD_SAMSUNG_PAY_PAY_MONEY_BANNER',
    PAYMENT_METHOD_PAY_LATER_BANNER: 'PAYMENT_METHOD_PAY_LATER_BANNER',
    PAYMENT_METHOD_BENEFIT_INFO: 'PAYMENT_METHOD_BENEFIT_INFO',
    PAYMENT_METHOD_CONNECT_EASY_ACCOUNT_BY_DISCONNECT_PAYMONEY_USER:
        'PAYMENT_METHOD_CONNECT_EASY_ACCOUNT_BY_DISCONNECT_PAYMONEY_USER',
    PAYMENT_METHOD_REFRESH_PAYMONEY_AMOUNT: 'PAYMENT_METHOD_REFRESH_PAYMONEY_AMOUNT',
    PAYMENT_METHOD_RECHARGE_POINT_INFO: 'PAYMENT_METHOD_RECHARGE_POINT_INFO',
    PAYMENT_METHOD_PAYMONEY_INFO: 'PAYMENT_METHOD_PAYMONEY_INFO',
    PAYMENT_METHOD_TITLE: 'PAYMENT_METHOD_TITLE',
    PAYMENT_METHOD_NOTICE: 'PAYMENT_METHOD_NOTICE',
    PAYMENT_METHOD_PAY_NEXT_SELECT_ON: 'PAYMENT_METHOD_PAY_NEXT_SELECT_ON',
    PAYMENT_METHOD_PAY_NEXT_TIMELINE: 'PAYMENT_METHOD_PAY_NEXT_TIMELINE',
    PAYMENT_METHOD_PAY_NEXT_TOOLTIP: 'PAYMENT_METHOD_PAY_NEXT_TOOLTIP',
    PAYMENT_METHOD_PAY_NEXT_ADD_ACCOUNT: 'PAYMENT_METHOD_PAY_NEXT_ADD_ACCOUNT',
    PAYMENT_METHOD_PAY_NEXT_ADD_CARD: 'PAYMENT_METHOD_PAY_NEXT_ADD_CARD',
    PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_BUTTON: 'PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_BUTTON',
    PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_WEEK_CLOSE: 'PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_WEEK_CLOSE',
    PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_CLOSE: 'PAYMENT_METHOD_VIRTUAL_ACCOUNT_TOOLTIP_CLOSE',
    PAYMENT_METHOD_NO_PAYMENT: 'PAYMENT_METHOD_NO_PAYMENT',
    PAYMENT_METHOD_REGIST_FIRST_EASY_PAYMENT_METHOD: 'PAYMENT_METHOD_REGIST_FIRST_EASY_PAYMENT_METHOD',
    PAYMENT_METHOD_REGIST_FIRST_EASY_CARD: 'PAYMENT_METHOD_REGIST_FIRST_EASY_CARD',
    PAYMENT_METHOD_REGIST_FIRST_EASY_BANK: 'PAYMENT_METHOD_REGIST_FIRST_EASY_BANK',
} as const

const CashReceiptEvent = {
    CASH_RECEIPT_INFO: 'CASH_RECEIPT_INFO',
    CASH_RECEIPT_ISSUE_ON: 'CASH_RECEIPT_ISSUE_ON',
    CASH_RECEIPT_ISSUE_OFF: 'CASH_RECEIPT_ISSUE_OFF',
    CASH_RECEIPT_ISSUE_FOR_PERSONAL: 'CASH_RECEIPT_ISSUE_FOR_PERSONAL',
    CASH_RECEIPT_ISSUE_FOR_BUSINESS: 'CASH_RECEIPT_ISSUE_FOR_BUSINESS',
    CASH_RECEIPT_CHANGE_INFO: 'CASH_RECEIPT_CHANGE_INFO',
    CASH_RECEIPT_CHANGE_PERSONAL_ISSUE_TYPE: 'CASH_RECEIPT_CHANGE_PERSONAL_ISSUE_TYPE',
    CASH_RECEIPT_SAVE_INFO: 'CASH_RECEIPT_SAVE_INFO',
} as const

const OrderTotalEvent = {
    ORDER_TOTAL_TOGGLE: 'ORDER_TOTAL_TOGGLE',
} as const

const SubmitButtonEvent = {
    SUBMIT_CLICK_BUTTON: 'SUBMIT_CLICK_BUTTON',
    FLOATING_SUBMIT_CLICK_BUTTON: 'FLOATING_SUBMIT_CLICK_BUTTON',
    FLOATING_MODAL_SUBMIT_CLICK_BUTTON: 'FLOATING_MODAL_SUBMIT_CLICK_BUTTON',
    FLOATING_MODAL_OPEN: 'FLOATING_MODAL_OPEN',
    FLOATING_MODAL_CLOSE: 'FLOATING_MODAL_CLOSE',
    FLOATING_MODAL_DETAIL: 'FLOATING_MODAL_DETAIL',
    FLOATING_MODAL_ALCOHOL: 'FLOATING_MODAL_ALCOHOL',
    FLOATING_MODAL_OVERSEAS: 'FLOATING_MODAL_OVERSEAS',
    FLOATING_MODAL_CUSTOM: 'FLOATING_MODAL_CUSTOM',
    FLOATING_MODAL_PREORDER: 'FLOATING_MODAL_PREORDER',
    FLOATING_MODAL_ESCROW: 'FLOATING_MODAL_ESCROW',
} as const

const AccumulatePointEvent = {
    ACCUMULATE_POINT_TOGGLE: 'ACCUMULATE_POINT_TOGGLE',
    ACCUMULATE_POINT_TOGGLE_BENEFIT_TOOLTIP: 'ACCUMULATE_POINT_TOGGLE_BENEFIT_TOOLTIP',
    ACCUMULATE_POINT_TOGGLE_MEMBERSHIP_BENEFIT_TOOLTIP: 'ACCUMULATE_POINT_TOGGLE_MEMBERSHIP_BENEFIT_TOOLTIP',
    ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP: 'ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP',
    ACCUMULATE_POINT_MEMBERSHIP_LINE_BANNER: 'ACCUMULATE_POINT_MEMBERSHIP_LINE_BANNER',
    ACCUMULATE_POINT_MEMBERSHIP_REJOIN_LINE_BANNER: 'ACCUMULATE_POINT_MEMBERSHIP_REJOIN_LINE_BANNER',
    ACCUMULATE_POINT_MEMBERSHIP_POPUP_BUTTON: 'ACCUMULATE_POINT_MEMBERSHIP_POPUP_BUTTON',
    ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_ON: 'ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_ON',
    ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_OFF: 'ACCUMULATE_POINT_FAMILY_PAY_TOOLTIP_OFF',
} as const

const AgreementEvent = {
    AGREEMENT_CLICK_PROVIDER_DETAIL: 'AGREEMENT_CLICK_PROVIDER_DETAIL',
    AGREEMENT_FAMILY_PAY: 'AGREEMENT_FAMILY_PAY',
    AGREEMENT_FAMILY_PAY_TOOLTIP_ON: 'AGREEMENT_FAMILY_PAY_TOOLTIP_ON',
    AGREEMENT_FAMILY_PAY_TOOLTIP_OFF: 'AGREEMENT_FAMILY_PAY_TOOLTIP_OFF',
    AGREEMENT_FAMILY_PAY_MINOR_TOOLTIP_OFF: 'AGREEMENT_FAMILY_PAY_MINOR_TOOLTIP_OFF',
} as const

const DeliveryEvent = {
    DELIVERY_ADDRESS_CHANGE_BUTTON: 'DELIVERY_ADDRESS_CHANGE_BUTTON',
    DELIVERY_VIRTUAL_PHONE_NUMBER_CHECKBOX: 'DELIVERY_VIRTUAL_PHONE_NUMBER_CHECKBOX',
    DELIVERY_VIRTUAL_PHONE_NUMBER_INFO: 'DELIVERY_VIRTUAL_PHONE_NUMBER_INFO',
    DELIVERY_VIRTUAL_PHONE_NUMBER_INFO_CLOSE_BUTTON: 'DELIVERY_VIRTUAL_PHONE_NUMBER_INFO_CLOSE_BUTTON',
    DELIVERY_INDIVIDUAL_MEMO_USE_CHECKBOX: 'DELIVERY_INDIVIDUAL_MEMO_USE_CHECKBOX',
    DELIVERY_MEMO_SELECT: 'DELIVERY_MEMO_SELECT',
    DELIVERY_MEMO: 'DELIVERY_MEMO',
    DELIVERY_MEMO_SETTING_BUTTON: 'DELIVERY_MEMO_SETTING_BUTTON',
    DELIVERY_MEMO_DELETE_BUTTON: 'DELIVERY_MEMO_DELETE_BUTTON',
    DELIVERY_DELIVERY_INSTRUCTION_ADD_BUTTON: 'DELIVERY_DELIVERY_INSTRUCTION_ADD_BUTTON',
    DELIVERY_DELIVERY_INSTRUCTION_MODIFY_BUTTON: 'DELIVERY_DELIVERY_INSTRUCTION_MODIFY_BUTTON',
    DELIVERY_DELIVERY_INSTRUCTION_ALWAYS_USE_CHECKBOX: 'DELIVERY_DELIVERY_INSTRUCTION_ALWAYS_USE_CHECKBOX',
    DELIVERY_DELIVERY_INSTRUCTION_CONFIRM_BUTTON: 'DELIVERY_DELIVERY_INSTRUCTION_CONFIRM_BUTTON',
    DELIVERY_INVALID_MODIFY_BUTTON: 'DELIVERY_INVALID_MODIFY_BUTTON',
    ORDERSHEET_DELIVERY_MEMO_REUSE_CHECKBOX: 'ORDERSHEET_DELIVERY_MEMO_REUSE_CHECKBOX',

    PERSONAL_CUSTOMS_CLEARANCE_EDIT_BUTTON: 'PERSONAL_CUSTOMS_CLEARANCE_EDIT_BUTTON',
    PERSONAL_CUSTOMS_CLEARANCE_INPUT_BUTTON: 'PERSONAL_CUSTOMS_CLEARANCE_INPUT_BUTTON',
    PERSONAL_CUSTOMS_CLEARANCE_RADIO_ON: 'PERSONAL_CUSTOMS_CLEARANCE_RADIO_ON',
    PERSONAL_CUSTOMS_CLEARANCE_RADIO_OFF: 'PERSONAL_CUSTOMS_CLEARANCE_RADIO_OFF',
    PERSONAL_CUSTOMS_CLEARANCE_REQUEST: 'PERSONAL_CUSTOMS_CLEARANCE_REQUEST',
    PERSONAL_CUSTOMS_CLEARANCE_VIEW: 'PERSONAL_CUSTOMS_CLEARANCE_VIEW',
    PERSONAL_CUSTOMS_CLEARANCE_OPEN_UNIPASS: 'PERSONAL_CUSTOMS_CLEARANCE_OPEN_UNIPASS',
    PERSONAL_CUSTOMS_CLEARANCE_CALL: 'PERSONAL_CUSTOMS_CLEARANCE_CALL',
    PERSONAL_CUSTOMS_CLEARANCE_SAVE: 'PERSONAL_CUSTOMS_CLEARANCE_SAVE',
    PERSONAL_CUSTOMS_CLEARANCE_GO_UNIPASS: 'PERSONAL_CUSTOMS_CLEARANCE_GO_UNIPASS',
    PERSONAL_CUSTOMS_CLEARANCE_MODIFY_ADDR: 'PERSONAL_CUSTOMS_CLEARANCE_MODIFY_ADDR',
    PERSONAL_CUSTOMS_CLEARANCE_SAVE_ADDR: 'PERSONAL_CUSTOMS_CLEARANCE_SAVE_ADDR',
    PERSONAL_CUSTOMS_CLEARANCE_CONFIRM: 'PERSONAL_CUSTOMS_CLEARANCE_CONFIRM',
    PERSONAL_CUSTOMS_CLEARANCE_AGREE_SAVE: 'PERSONAL_CUSTOMS_CLEARANCE_AGREE_SAVE',
    PERSONAL_CUSTOMS_CLEARANCE_CLOSE: 'PERSONAL_CUSTOMS_CLEARANCE_CLOSE',
    PERSONAL_CUSTOMS_CLEARANCE_FAILURE: 'PERSONAL_CUSTOMS_CLEARANCE_FAILURE',
    PERSONAL_CUSTOMS_CLEARANCE_FAILURE_SAVE: 'PERSONAL_CUSTOMS_CLEARANCE_FAILURE_SAVE',
} as const

const DeliveryManagerEvent = {
    ORDERSHEET_ADDRESS_BOOK_BACK_BUTTON: 'ORDERSHEET_ADDRESS_BOOK_BACK_BUTTON',
    RESULT_ADDRESS_BOOK_BACK_BUTTON: 'RESULT_ADDRESS_BOOK_BACK_BUTTON',
    ORDERSHEET_ADDRESS_BOOK_ADD_BUTTON: 'ORDERSHEET_ADDRESS_BOOK_ADD_BUTTON',
    RESULT_ADDRESS_BOOK_ADD_BUTTON: 'RESULT_ADDRESS_BOOK_ADD_BUTTON',
    ORDERSHEET_ADDRESS_BOOK_ADDRESS: 'ORDERSHEET_ADDRESS_BOOK_ADDRESS',
    RESULT_ADDRESS_BOOK_ADDRESS: 'RESULT_ADDRESS_BOOK_ADDRESS',
    ORDERSHEET_ADDRESS_BOOK_EDIT_BUTTON: 'ORDERSHEET_ADDRESS_BOOK_EDIT_BUTTON',
    RESULT_ADDRESS_BOOK_EDIT_BUTTON: 'RESULT_ADDRESS_BOOK_EDIT_BUTTON',
    ORDERSHEET_ADDRESS_BOOK_REGISTER_BUTTON: 'ORDERSHEET_ADDRESS_BOOK_REGISTER_BUTTON',
    RESULT_ADDRESS_BOOK_REGISTER_BUTTON: 'RESULT_ADDRESS_BOOK_REGISTER_BUTTON',
    ORDERSHEET_ADDRESS_BOOK_DELETE_BUTTON: 'ORDERSHEET_ADDRESS_BOOK_DELETE_BUTTON',
    RESULT_ADDRESS_BOOK_DELETE_BUTTON: 'RESULT_ADDRESS_BOOK_DELETE_BUTTON',
    ORDERSHEET_ADDRESS_BOOK_SHOW_ALL_BUTTON: 'ORDERSHEET_ADDRESS_BOOK_SHOW_ALL_BUTTON',
    RESULT_ADDRESS_BOOK_SHOW_ALL_BUTTON: 'RESULT_ADDRESS_BOOK_SHOW_ALL_BUTTON',
    RESULT_ADDRESS_BOOK_CONFIRM_BUTTON: 'RESULT_ADDRESS_BOOK_CONFIRM_BUTTON',
    ORDERSHEET_ADDRESS_FORM_RECEIVER: 'ORDERSHEET_ADDRESS_FORM_RECEIVER',
    RESULT_ADDRESS_FORM_RECEIVER: 'RESULT_ADDRESS_FORM_RECEIVER',
    ORDERSHEET_ADDRESS_FORM_PHONE_NUMBER: 'ORDERSHEET_ADDRESS_FORM_PHONE_NUMBER',
    RESULT_ADDRESS_FORM_PHONE_NUMBER: 'RESULT_ADDRESS_FORM_PHONE_NUMBER',
    ORDERSHEET_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER: 'ORDERSHEET_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER',
    RESULT_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER: 'RESULT_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER',
    ORDERSHEET_ADDRESS_FORM_PRESET_HOME: 'ORDERSHEET_ADDRESS_FORM_PRESET_HOME',
    RESULT_ADDRESS_FORM_PRESET_HOME: 'RESULT_ADDRESS_FORM_PRESET_HOME',
    ORDERSHEET_ADDRESS_FORM_PRESET_OFFICE: 'ORDERSHEET_ADDRESS_FORM_PRESET_OFFICE',
    RESULT_ADDRESS_FORM_PRESET_OFFICE: 'RESULT_ADDRESS_FORM_PRESET_OFFICE',
    ORDERSHEET_ADDRESS_FORM_PRESET_SCHOOL: 'ORDERSHEET_ADDRESS_FORM_PRESET_SCHOOL',
    RESULT_ADDRESS_FORM_PRESET_SCHOOL: 'RESULT_ADDRESS_FORM_PRESET_SCHOOL',
    ORDERSHEET_ADDRESS_FORM_PRESET_FRIEND: 'ORDERSHEET_ADDRESS_FORM_PRESET_FRIEND',
    RESULT_ADDRESS_FORM_PRESET_FRIEND: 'RESULT_ADDRESS_FORM_PRESET_FRIEND',
    ORDERSHEET_ADDRESS_FORM_PRESET_FAMILY: 'ORDERSHEET_ADDRESS_FORM_PRESET_FAMILY',
    RESULT_ADDRESS_FORM_PRESET_FAMILY: 'RESULT_ADDRESS_FORM_PRESET_FAMILY',
    ORDERSHEET_ADDRESS_FORM_PRESET_MANUAL: 'ORDERSHEET_ADDRESS_FORM_PRESET_MANUAL',
    RESULT_ADDRESS_FORM_PRESET_MANUAL: 'RESULT_ADDRESS_FORM_PRESET_MANUAL',
    ORDERSHEET_ADDRESS_FORM_SEARCH_ADDRESS: 'ORDERSHEET_ADDRESS_FORM_SEARCH_ADDRESS',
    RESULT_ADDRESS_FORM_SEARCH_ADDRESS: 'RESULT_ADDRESS_FORM_SEARCH_ADDRESS',
    ORDERSHEET_ADDRESS_FORM_DETAIL_ADDRESS: 'ORDERSHEET_ADDRESS_FORM_DETAIL_ADDRESS',
    RESULT_ADDRESS_FORM_DETAIL_ADDRESS: 'RESULT_ADDRESS_FORM_DETAIL_ADDRESS',
    ORDERSHEET_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX: 'ORDERSHEET_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX',
    RESULT_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX: 'RESULT_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX',
    RESULT_ADDRESS_FORM_SET_AS_VIRTUAL_NUMBER_USED_CHECKBOX: 'RESULT_ADDRESS_FORM_SET_AS_VIRTUAL_NUMBER_USED_CHECKBOX',
    ORDERSHEET_ADDRESS_FORM_CONFIRM: 'ORDERSHEET_ADDRESS_FORM_CONFIRM',
    RESULT_ADDRESS_FORM_CONFIRM: 'RESULT_ADDRESS_FORM_CONFIRM',
    ORDERSHEET_ZIP_CODE_SEARCH_BUTTON: 'ORDERSHEET_ZIP_CODE_SEARCH_BUTTON',
    RESULT_ZIP_CODE_SEARCH_BUTTON: 'RESULT_ZIP_CODE_SEARCH_BUTTON',
    EXTERNAL_ZIP_CODE_SEARCH_BUTTON: 'EXTERNAL_ZIP_CODE_SEARCH_BUTTON',
    ORDERSHEET_ZIP_CODE_RESULT: 'ORDERSHEET_ZIP_CODE_RESULT',
    RESULT_ZIP_CODE_RESULT: 'RESULT_ZIP_CODE_RESULT',
    EXTERNAL_ZIP_CODE_RESULT: 'EXTERNAL_ZIP_CODE_RESULT',
    ORDERSHEET_ZIP_CODE_RESULT_PAGINATION: 'ORDERSHEET_ZIP_CODE_RESULT_PAGINATION',
    RESULT_ZIP_CODE_RESULT_PAGINATION: 'RESULT_ZIP_CODE_RESULT_PAGINATION',
    EXTERNAL_ZIP_CODE_RESULT_PAGINATION: 'EXTERNAL_ZIP_CODE_RESULT_PAGINATION',
    RESULT_VIRTUAL_PHONE_NUMBER_CHECKBOX: 'RESULT_VIRTUAL_PHONE_NUMBER_CHECKBOX',
    RESULT_VIRTUAL_PHONE_NUMBER_INFO: 'RESULT_VIRTUAL_PHONE_NUMBER_INFO',
    RESULT_DELIVERY_MEMO_SELECT: 'RESULT_DELIVERY_MEMO_SELECT',
    RESULT_DELIVERY_MEMO_TEXTAREA: 'RESULT_DELIVERY_MEMO_TEXTAREA',
    ADDRESS_DELETE_CONFIRM_BUTTON: 'ADDRESS_DELETE_CONFIRM_BUTTON',
    RESULT_DELIVERY_MEMO_REUSE_CHECKBOX: 'RESULT_DELIVERY_MEMO_REUSE_CHECKBOX',
} as const

const DigitalContentsEasyRegisterEvent = {
    EASY_REGISTER_PROCESS_PAGE: 'EASY_REGISTER_PROCESS_PAGE',
} as const

const CancelButtonEvent = {
    CANCEL_CLICK_BUTTON: 'CANCEL_CLICK_BUTTON',
} as const

const ReceiverEvent = {
    RECEIVER_TITLE_AREA: 'RECEIVER_TITLE_AREA',
    RECEIVER_INFO_AUTO_FILL: 'RECEIVER_INFO_AUTO_FILL',
    RECEIVER_INDIVIDUAL_MEMO_USE_CHECKBOX: 'RECEIVER_INDIVIDUAL_MEMO_USE_CHECKBOX',
    RECEIVER_MEMO: 'RECEIVER_MEMO',
} as const

const PurchaserEvent = {
    PURCHASER_TITLE_AREA: 'PURCHASER_TITLE_AREA',
    PURCHASER_INFO_CHANGE: 'PURCHASER_INFO_CHANGE',
} as const

const ProductEvent = {
    PRODUCT_SELECT_DELIVERY_COUPON_ITEM: 'PRODUCT_SELECT_DELIVERY_COUPON_ITEM',
    PRODUCT_CANCEL_DELIVERY_COUPON_ITEM: 'PRODUCT_CANCEL_DELIVERY_COUPON_ITEM',
    PRODUCT_SELECT_IMMEDIATE_COUPON_ITEM: 'PRODUCT_SELECT_IMMEDIATE_COUPON_ITEM',
    PRODUCT_CANCEL_IMMEDIATE_COUPON_ITEM: 'PRODUCT_CANCEL_IMMEDIATE_COUPON_ITEM',
    PRODUCT_SELECT_ADDITIONAL_COUPON_ITEM: 'PRODUCT_SELECT_ADDITIONAL_COUPON_ITEM',
    PRODUCT_CANCEL_ADDITIONAL_COUPON_ITEM: 'PRODUCT_CANCEL_ADDITIONAL_COUPON_ITEM',
    PRODUCT_SELECT_NAVER_COUPON_ITEM: 'PRODUCT_SELECT_NAVER_COUPON_ITEM',
    PRODUCT_CANCEL_NAVER_COUPON_ITEM: 'PRODUCT_CANCEL_NAVER_COUPON_ITEM',
    PRODUCT_SELECT_STORE_COUPON_ITEM: 'PRODUCT_SELECT_STORE_COUPON_ITEM',
    PRODUCT_CANCEL_STORE_COUPON_ITEM: 'PRODUCT_CANCEL_STORE_COUPON_ITEM',
    PRODUCT_TITLE: 'PRODUCT_TITLE',
    PRODUCT_NAME: 'PRODUCT_NAME',
    PRODUCT_THUMBNAIL: 'PRODUCT_THUMBNAIL',
    SHOPPING_MALL_NAME: 'SHOPPING_MALL_NAME',
    MERCHANT_PRODUCT_COUPON_SELECT: 'MERCHANT_PRODUCT_COUPON_SELECT',
    DUPLICATED_PRODUCT_COUPON_SELECT: 'DUPLICATED_PRODUCT_COUPON_SELECT',
    MANAGER_PRODUCT_COUPON_SELECT: 'MANAGER_PRODUCT_COUPON_SELECT',
    DELIVERY_COUPON_SELECT: 'DELIVERY_COUPON_SELECT',
    STORE_COUPON_SELECT: 'STORE_COUPON_SELECT',
} as const

const OrderFailEvent = {
    FAILURE_REORDER: 'FAILURE_REORDER',
    FAILURE_GO_SHOPPING_HOME: 'FAILURE_GO_SHOPPING_HOME',
} as const

const ApprovalFailPayLaterBannerEvent = {
    APPROVAL_FAIL_REORDER: 'APPROVAL_FAIL_REORDER',
    APPROVAL_FAIL_GO_SHOPPING_HOME: 'APPROVAL_FAIL_GO_SHOPPING_HOME',
    APPROVAL_FAIL_PAYLATER_USE_BANNER_SHOW: 'APPROVAL_FAIL_PAYLATER_USE_BANNER_SHOW',
    APPROVAL_FAIL_PAYLATER_USE_BANNER_CLICK: 'APPROVAL_FAIL_PAYLATER_USE_BANNER_CLICK',
    APPROVAL_FAIL_PAYLATER_JOIN_BANNER_SHOW: 'APPROVAL_FAIL_PAYLATER_JOIN_BANNER_SHOW',
    APPROVAL_FAIL_PAYLATER_JOIN_BANNER_CLICK: 'APPROVAL_FAIL_PAYLATER_JOIN_BANNER_CLICK',
} as const

const DialogEvent = {
    PAYLATER_OVERDUE_REDEEM: 'PAYLATER_OVERDUE_REDEEM',
    PAYLATER_OVERDUE_CLOSE: 'PAYLATER_OVERDUE_CLOSE',
} as const

const HeaderEvent = {
    SINGLE_COLUMN_HEADER_LOGO: 'SINGLE_COLUMN_HEADER_LOGO',
    SINGLE_COLUMN_HEADER_CLOSE: 'SINGLE_COLUMN_HEADER_CLOSE',
    RESULT_HEADER_CART: 'RESULT_CART',
    RESULT_HEADER_SHOPPING_HOME: 'RESULT_HEADER_SHOPPING_HOME',
} as const

const OrderResultNextEvent = {
    RESULT_LOGO: 'RESULT_LOGO',
    DELIVERY_CHANGE: 'DELIVERY_CHANGE',
    ORDER_LIST: 'ORDER_LIST',
    TIMELINE: 'TIMELINE',
    PAY_NOW: 'PAY_NOW',
    ORDER_LIST_BUTTON: 'ORDER_LIST_BUTTON',
    SHOPPING_HOME_BUTTON: 'SHOPPING_HOME_BUTTON',
    GFD_BANNER_CLOSE: 'GFD_BANNER_CLOSE',
    GFD_BANNER_WEEK_CLOSE: 'GFD_BANNER_WEEK_CLOSE',
    DELIVERY_MEMO_DETAIL: 'DELIVERY_MEMO_DETAIL',
    NO_CERTIFICATION_BANNER_TYPE_A: 'NO_CERTIFICATION_BANNER_TYPE_A',
    NO_CERTIFICATION_BANNER_TYPE_B: 'NO_CERTIFICATION_BANNER_TYPE_B',
    MEMBERSHIP_GUIDE: 'MEMBERSHIP_GUIDE',
    MEMBERSHIP_ANNUAL_GUIDE: 'MEMBERSHIP_ANNUAL_GUIDE',
    MEMBERSHIP_PROMOTION_GUIDE: 'MEMBERSHIP_PROMOTION_GUIDE',
    DELIVERY_MEMO_CHANGE_BUTTON: 'DELIVERY_MEMO_CHANGE_BUTTON',
    ORDER_NO: 'ORDER_NO',
    ORDER_ITEM_OPEN: 'ORDER_DETAIL_OPEN',
    ORDER_ITEM_FOLD: 'ORDER_DETAIL_FOLD',
    ORDER_DETAIL: 'ORDER_DETAIL_MOVE',
    VIRTUAL_ACCOUNT_NUMBER: 'VIRTUAL_ACCOUNT_NUMBER',
    ECOUPON_BARCODE_INFO: 'ECOUPON_BARCODE_INFO',
    FAMILY_PAY_MEMBER: 'FAMILY_PAY_MEMBER',
    FAMILY_PAY_ORGANIZER: 'FAMILY_PAY_ORGANIZER',
    FAMILY_PAY_REQUEST: 'FAMILY_PAY_REQUEST',
    FAMILY_PAY_SHARE_KAKAO_TALK: 'FAMILY_PAY_SHARE_KAKAO_TALK',
    FAMILY_PAY_SHARE_SMS: 'FAMILY_PAY_SHARE_SMS',
    FAMILY_PAY_SHARE_TALK_TALK: 'FAMILY_PAY_SHARE_TALK_TALK',
    FAMILY_PAY_SHARE_CLOSE: 'FAMILY_PAY_SHARE_CLOSE',
    FAMILY_PAY_SHARE_CONFIRM: 'FAMILY_PAY_SHARE_CONFIRM',
} as const

const PlccBannerEvent = {
    HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK: 'HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK',
    HYUNDAI_CARD_TYPE_BANNER_CLICK: 'HYUNDAI_CARD_TYPE_BANNER_CLICK',
    HYUNDAI_GET_BENEFIT_NOW_CLICK: 'HYUNDAI_GET_BENEFIT_NOW_CLICK',
    SAMSUNG_TAPTAP_FOCUSING_INDUCTION_BANNER_CLICK: 'SAMSUNG_TAPTAP_FOCUSING_INDUCTION_BANNER_CLICK',
    SAMSUNG_TAPTAP_CARD_TYPE_BANNER_CLICK: 'SAMSUNG_TAPTAP_CARD_TYPE_BANNER_CLICK',
    SAMSUNG_TAPTAP_GET_BENEFIT_NOW_CLICK: 'SAMSUNG_TAPTAP_GET_BENEFIT_NOW_CLICK',
    NAVERPAY_MONEY_FOCUSING_INDUCTION_BANNER_CLICK: 'NAVERPAY_MONEY_FOCUSING_INDUCTION_BANNER_CLICK',
    NAVERPAY_MONEY_CARD_TYPE_BANNER_CLICK: 'NAVERPAY_MONEY_CARD_TYPE_BANNER_CLICK',
    NAVERPAY_MONEY_GET_BENEFIT_NOW_CLICK: 'NAVERPAY_MONEY_GET_BENEFIT_NOW_CLICK',
    SHINHAN_LINE_FRIENDS_FOCUSING_INDUCTION_BANNER_CLICK: 'SHINHAN_LINE_FRIENDS_FOCUSING_INDUCTION_BANNER_CLICK',
    SHINHAN_LINE_FRIENDS_CARD_TYPE_BANNER_CLICK: 'SHINHAN_LINE_FRIENDS_CARD_TYPE_BANNER_CLICK',
    SHINHAN_LINE_FRIENDS_GET_BENEFIT_NOW_CLICK: 'SHINHAN_LINE_FRIENDS_GET_BENEFIT_NOW_CLICK',
    LOTTE_NPAY_LOCA_FOCUSING_INDUCTION_BANNER_CLICK: 'LOTTE_NPAY_LOCA_FOCUSING_INDUCTION_BANNER_CLICK',
    LOTTE_NPAY_LOCA_CARD_TYPE_BANNER_CLICK: 'LOTTE_NPAY_LOCA_CARD_TYPE_BANNER_CLICK',
    LOTTE_NPAY_LOCA_GET_BENEFIT_NOW_CLICK: 'LOTTE_NPAY_LOCA_GET_BENEFIT_NOW_CLICK',
} as const

const PromotionBannerEvent = {
    PROMOTION_HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK: 'PROMOTION_HYUNDAI_FOCUSING_INDUCTION_BANNER_CLICK',
    PROMOTION_HYUNDAI_CARD_TYPE_BANNER_CLICK: 'PROMOTION_HYUNDAI_CARD_TYPE_BANNER_CLICK',
    PROMOTION_HYUNDAI_GET_BENEFIT_NOW_CLICK: 'PROMOTION_HYUNDAI_GET_BENEFIT_NOW_CLICK',
    PROMOTION_LOTTE_FOCUSING_INDUCTION_BANNER_CLICK: 'PROMOTION_LOTTE_FOCUSING_INDUCTION_BANNER_CLICK',
    PROMOTION_LOTTE_CARD_TYPE_BANNER_CLICK: 'PROMOTION_LOTTE_CARD_TYPE_BANNER_CLICK',
    PROMOTION_LOTTE_GET_BENEFIT_NOW_CLICK: 'PROMOTION_LOTTE_GET_BENEFIT_NOW_CLICK',
    PROMOTION_SHINHAN_FOCUSING_INDUCTION_BANNER_CLICK: 'PROMOTION_SHINHAN_FOCUSING_INDUCTION_BANNER_CLICK',
    PROMOTION_SHINHAN_CARD_TYPE_BANNER_CLICK: 'PROMOTION_SHINHAN_CARD_TYPE_BANNER_CLICK',
    PROMOTION_SHINHAN_GET_BENEFIT_NOW_CLICK: 'PROMOTION_SHINHAN_GET_BENEFIT_NOW_CLICK',
    PROMOTION_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK: 'PROMOTION_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK',
    PROMOTION_SAMSUNG_CARD_TYPE_BANNER_CLICK: 'PROMOTION_SAMSUNG_CARD_TYPE_BANNER_CLICK',
    PROMOTION_SAMSUNG_GET_BENEFIT_NOW_CLICK: 'PROMOTION_SAMSUNG_GET_BENEFIT_NOW_CLICK',
    PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK:
        'PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_FOCUSING_INDUCTION_BANNER_CLICK',
    PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_BANNER_CLICK: 'PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_BANNER_CLICK',
    PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_GET_BENEFIT_NOW_CLICK:
        'PROMOTION_KOOKMIN_HAPPINESS_SAMSUNG_GET_BENEFIT_NOW_CLICK',
} as const

const GeneralBannerEvent = {
    MEMBERSHIP_PLCC_BANNER_CLICK: 'MEMBERSHIP_PLCC_BANNER_CLICK',
    SHINHAN_PARTNERSHIP_BANNER_CLICK: 'SHINHAN_PARTNERSHIP_BANNER_CLICK',
} as const

const CardPromotionEvent = {
    PROMOTION_DETAIL_BUTTON_CLICK: 'PROMOTION_DETAIL_BUTTON_CLICK',
    PROMOTION_SELECT: 'PROMOTION_SELECT',
    /** @deprecated ui개선 적용 이후 */
    PROMOTION_CLEAR_BUTTON: 'PROMOTION_CLEAR_BUTTON',
    // ui 개선이후 사용
    PROMOTION_CLEAR: 'PROMOTION_CLEAR',
} as const

const SubmitValidationEvent = {
    DELIVERY_INPUT_FAIL: 'DELIVERY_INPUT_FAIL',
    DELIVERY_RECEIVER_NAME_FAIL: 'DELIVERY_RECEIVER_NAME',
    DELIVERY_RECEIVER_NAME_MAX_FAIL: 'DELIVERY_RECEIVER_NAME_MAX_FAIL',
    DELIVERY_DETAIL_ADDRESS_MAX_FAIL: 'DELIVERY_DETAIL_ADDRESS_MAX_FAIL',
    DELIVERY_ADDRESS_NAME_MAX_FAIL: 'DELIVERY_ADDRESS_NAME_MAX_FAIL',
    DELIVERY_PHONE_NUMBER_FAIL: 'DELIVERY_PHONE_NUMBER_FAIL',
    DELIVERY_PHONE_NUMBER_TWO_FAIL: 'DELIVERY_PHONE_NUMBER_TWO_FAIL',
    DELIVERY_KOREA_ADDRESS_FAIL: 'DELIVERY_KOREA_ADDRESS_FAIL',
    DELIVERY_ROAD_DETAIL_NONE: 'DELIVERY_ROAD_DETAIL_NONE',
    DELIVERY_LOT_DETAIL_NONE: 'DELIVERY_LOT_DETAIL_NONE',
    PERSONAL_CUSTOMS_CODE_FAIL: 'PERSONAL_CUSTOMS_CODE_FAIL',
    PERSONAL_CUSTOMS_CLEARANCE_CHECK_FAIL: 'PERSONAL_CUSTOMS_CLEARANCE_CHECK_FAIL',
    RECEIVER_NAME_FAIL: 'RECEIVER_NAME_FAIL',
    RECEIVER_PHONE_NUMBER_FAIL: 'RECEIVER_PHONE_NUMBER_FAIL',
    MEMO_MAX_FAIL: 'MEMO_MAX_FAIL',
    CASH_RECEIPT_PHONE_NUMBER_FAIL: 'CASH_RECEIPT_PHONE_NUMBER_FAIL',
    CASH_RECEIPT_SOCIAL_FAIL: 'CASH_RECEIPT_SOCIAL_FAIL',
    CASH_RECEIPT_CARD_FAIL: 'CASH_RECEIPT_CARD_FAIL',
    CASH_RECEIPT_BUSINESS_REGISTRATION: 'CASH_RECEIPT_BUSINESS_REGISTRATION',
    ADDITIONAL_ORDER_OPTIONS_FAIL: 'ADDITIONAL_ORDER_OPTIONS_FAIL',
    PAY_MONEY_USING_FAIL: 'PAY_MONEY_USING_FAIL',
    PAY_MONEY_DELETED: 'PAY_MONEY_DELETED',
    UNAVAILABLE_CHARGE_BANK: 'UNAVAILABLE_CHARGE_BANK',
    UNAVAILABLE_CHARGE_BANK_ACCOUNT: 'UNAVAILABLE_CHARGE_BANK_ACCOUNT',
    EMPTY_CHARGE_BANK: 'EMPTY_CHARGE_BANK',
    NONE_SELECTED_PAY_METHOD: 'NONE_SELECTED_PAY_METHOD',
    EMPTY_EASY_CARD: 'EMPTY_EASY_CARD',
    EMPTY_EASY_BANK: 'EMPTY_EASY_BANK',
    UNAVAILABLE_EASY_BANK: 'UNAVAILABLE_EASY_BANK',
    NEED_CARD_CODE: 'NEED_CARD_CODE',
    CANT_USE_CARD: 'CANT_USE_CARD',
    MOBILE_PHONE_NUMBER_FAIL: 'MOBILE_PHONE_NUMBER_FAIL',
    NEED_MOBILE_PASSWORD: 'NEED_MOBILE_PASSWORD',
    VIRTUAL_ACCOUNT_BANK_CODE_FAIL: 'VIRTUAL_ACCOUNT_BANK_CODE_FAIL',
    REFUND_ACCOUNT_CODE_FAIL: 'REFUND_ACCOUNT_CODE_FAIL',
    MINIMUM_MAXIMUM_AMOUNT_FAIL: 'MINIMUM_MAXIMUM_AMOUNT_FAIL',
    MINIMUM_AMOUNT_FAIL: 'MINIMUM_AMOUNT_FAIL',
    MAXIMUM_AMOUNT_FAIL: 'MAXIMUM_AMOUNT_FAIL',
    MAXIMUM_AMOUNT_FAIL_WITH_VIRTUAL_ACCOUNT_BANK: 'MAXIMUM_AMOUNT_FAIL_WITH_VIRTUAL_ACCOUNT_BANK',
    AGREEMENT_FAIL: 'AGREEMENT_FAIL',
    SELECT_ADDITIONAL_PAY_METHOD: 'SELECT_ADDITIONAL_PAY_METHOD',
    FDS_PAYMENT_SECURITY: 'FDS_PAYMENT_SECURITY',
    BLACK_CONSUMER: 'BLACK_CONSUMER',
    OPEN_BANKING_AGREED: 'OPEN_BANKING_AGREED',
    AGREEMENT_THIRD_PEOPLE: 'AGREEMENT_THIRD_PEOPLE',
    AGREEMENT_CUSTOM_ORDER: 'AGREEMENT_CUSTOM_ORDER',
    AGREEMENT_PRE_ORDER: 'AGREEMENT_PRE_ORDER',
    AGREEMENT_PERSONAL_DATA_CROSS_BORDER_TRANSFER: 'AGREEMENT_PERSONAL_DATA_CROSS_BORDER_TRANSFER',
    OVER_USING_AMOUNT: 'OVER_USING_AMOUNT',
    OVER_USING_REWARD_AMOUNT: 'OVER_USING_REWARD_AMOUNT',
    OVER_USING_CHARGE_AMOUNT: 'OVER_USING_CHARGE_AMOUNT',
    OVER_PAY_LATER_AMOUNT: 'OVER_PAY_LATER_AMOUNT',
    OVER_RECHARGING_AMOUNT: 'OVER_RECHARGING_AMOUNT',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    PRODUCT_STATUS: 'PRODUCT_STATUS',
    REGISTER_FIRST_EASY_PAYMENT: 'REGISTER_FIRST_EASY_PAYMENT',
    DEPRECATED_ZIPCODES: 'DEPRECATED_ZIPCODES',
    REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT:
        'REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT',
    COMMON_ENTRANCE_PASSWORD_GUIDE: 'COMMON_ENTRANCE_PASSWORD_GUIDE',
    PICKUP_LOCATION_GUIDE: 'PICKUP_LOCATION_GUIDE',
    PICKUP_LOCATION_NAME_MAX_FAIL: 'PICKUP_LOCATION_NAME_MAX_FAIL',
    ENTRY_METHOD_GUIDE: 'ENTRY_METHOD_GUIDE',
    ENTRY_METHOD_NAME_MAX_FAIL: 'ENTRY_METHOD_NAME_MAX_FAIL',
    ADDITIONAL_OPTIONS_FAIL: 'ADDITIONAL_OPTIONS_FAIL',
} as const

const ComponentExposedEvent = {
    /** 주문서 페이지 진입 */
    ENTER_ORDERSHEET: 'ENTER_ORDERSHEET',
    EXPOSED_DELIVERY: 'EXPOSED_DELIVERY',
    EXPOSED_PERSONAL_CUSTOMS_CLEARANCE: 'EXPOSED_PERSONAL_CUSTOMS_CLEARANCE',
    EXPOSED_PURCHASER: 'EXPOSED_PURCHASER',
    EXPOSED_PRODUCT: 'EXPOSED_PRODUCT',
    EXPOSED_NOT_OPENED_POINT: 'EXPOSED_NOT_OPENED_POINT',
    EXPOSED_OPENED_POINT: 'EXPOSED_OPENED_POINT',
    EXPOSED_PAY_LATER_NOT_JOINED: 'EXPOSED_PAY_LATER_NOT_JOINED',
    EXPOSED_PAY_LATER_JOINED: 'EXPOSED_PAY_LATER_JOINED',
    EXPOSED_DISABLED_PAYMENT_METHOD: 'EXPOSED_DISABLED_PAYMENT_METHOD',
    EXPOSED_RECHARGE_PAYMENT: 'EXPOSED_RECHARGE_POINT_PAYMENT',
    EXPOSED_PAYMONEY_PAYMENT: 'EXPOSED_PAYMONEY_PAYMENT',
    EXPOSED_EASY_BANK_PAYMENT: 'EXPOSED_EASY_BANK_PAYMENT',
    EXPOSED_EASY_CARD_PAYMENT: 'EXPOSED_EASY_CARD_PAYMENT',
    EXPOSED_SAMSUNG_PAY_PAYMENT: 'EXPOSED_SAMSUNG_PAY_PAYMENT',
    EXPOSED_CREDIT_CARD_PAYMENT: 'EXPOSED_CREDIT_CARD_PAYMENT',
    EXPOSED_MOBILE_PAYMENT: 'EXPOSED_MOBILE_PAYMENT',
    EXPOSED_VIRTUAL_ACCOUNT: 'EXPOSED_VIRTUAL_ACCOUNT',
    EXPOSED_VOUCHER_PAYMENT: 'EXPOSED_VOUCHER_PAYMENT',
    EXPOSED_TMONEY_PAYMENT: 'EXPOSED_TMONEY_PAYMENT',
    EXPOSED_WELFARE_CARD_PAYMENT: 'EXPOSED_WELFARE_CARD_PAYMENT',
    EXPOSED_PAY_PAL_PAYMENT: 'EXPOSED_PAY_PAL_PAYMENT',
    EXPOSED_CASH_RECEIPT: 'EXPOSED_CASH_RECEIPT',
    EXPOSED_ORDER_DETAIL: 'EXPOSED_ORDER_DETAIL',
    EXPOSED_ACCUMULATE_POINT: 'EXPOSED_ACCUMULATE_POINT',
    EXPOSED_SUBMIT_BUTTON: 'EXPOSED_SUBMIT_BUTTON',
    ENTER_ORDER_FAILURE: 'ENTER_ORDER_FAILURE',
    ENTER_ORDER_APPLY_FAILURE: 'ENTER_ORDER_APPLY_FAILURE',
    ENTER_ORDER_SUCCEED: 'ENTER_ORDER_SUCCEED',
} as const

const WaitingEvent = {
    WAITING_GO_BACK: 'WAITING_GO_BACK',
} as const

export const UiEvent = {
    ...DigitalContentEvent,
    ...PaymentMethodEvent,
    ...PointPaymentEvent,
    ...CashReceiptEvent,
    ...OrderTotalEvent,
    ...AccumulatePointEvent,
    ...AgreementEvent,
    ...SubmitButtonEvent,
    ...DeliveryEvent,
    ...DigitalContentsEasyRegisterEvent,
    ...CancelButtonEvent,
    ...ReceiverEvent,
    ...PurchaserEvent,
    ...ProductEvent,
    ...ApprovalFailPayLaterBannerEvent,
    ...DialogEvent,
    ...HeaderEvent,
    ...OrderResultNextEvent,
    ...PlccBannerEvent,
    ...PromotionBannerEvent,
    ...GeneralBannerEvent,
    ...CardPromotionEvent,
    ...SubmitValidationEvent,
    ...DeliveryManagerEvent,
    ...ComponentExposedEvent,
    ...OrderFailEvent,
    ...WaitingEvent,
} as const

export type UiEventType = Constant<typeof UiEvent>

type UIEventActionPayload = {
    uiEvent: UiEventType
    event?: Event | React.SyntheticEvent
}
const uiEventAction = createAction<UIEventActionPayload>('uiEventAction')

export default uiEventAction
